import './App.css';
import React from 'react';
import AppStack from './routes/AppStack';

const App = () => {
  return (
    <AppStack />
  )
}

export default App;
